export type AnyRecord = object;
export interface DetailFormDisableProps<TModel extends AnyRecord = AnyRecord> {
  /** Disable all fields (overrides editMode) */
  allDisabled?: boolean;
  /** Disable certain fields by key */
  disabledFields?: Partial<Record<keyof TModel, boolean>>;
}

/** Extra props become generic over the model shape */
export interface DetailFormExtraProps<TModel extends AnyRecord = AnyRecord> {
  /** Initial form values (only applied when isNew === true) */
  initialData?: Partial<TModel> | null;

  /** Placeholders per field key */
  placeholders?: Placeholders<TModel> | null;

  /** Suggestions per field key */
  suggestions?: Partial<Record<keyof TModel, string[] | Record<string, any>[]>> | null;
}

export type Placeholders<T> = Partial<Record<keyof T, string>>;

export function buildPlaceholders<T extends Record<string, unknown>>(
  src: Partial<T>,
): Placeholders<T> {
  const result: Placeholders<T> = {};

  (Object.keys(src) as (keyof T)[]).forEach((key) => {
    const value = src[key];

    if (value == null || typeof value === 'object') return;

    // Everything else: stringify
    result[key] = String(value);
  });

  return result;
}
